// src/reducers/ncfRangeReducer.js

import { types } from '../types/types';

const initialState = {
    editingNCFRange: {
        id: 0,
        typeNcf: 0,
        validUntil: '',
        startSequence: 0,
        finalSequence: 0,
        ordinal: 0,
        taxPrefix: '',
        status: true,
    },
    availableNcfRange : [],
};

export const ncfRangeReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingNCFRangeInfo:
            return {
                ...state,
                editingNCFRange: action.payload,
            };

        case types.clearNCFRangeInfo:
            return {
                ...state,
                editingNCFRange: initialState.editingNCFRange,
            };

             case types.setAvailableNcfRange:
            return {
                ...state,
                availableNcfRange: action.payload
            };

        default:
            return state;
    }
};